// Anzeige der PA-Meldungen (Ersatz für MatSnackBar, siehe classes/pa-notifications.ts).
// Die Komponente hält keinen eigenen Zustand — sie spiegelt nur die jeweils aktive Meldung.

import { NgClass } from "@angular/common";
import { Component, DestroyRef, inject, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import type { PANotification, PANotificationAction } from "../../classes/pa-notifications";
import { PANotifications } from "../../classes/pa-notifications";

@Component({
  selector: "hawk-pa-notifications",
  templateUrl: "./pa-notifications.component.html",
  standalone: true,
  imports: [NgClass],
})
export class PaNotificationsComponent {
  private readonly destroyRef = inject(DestroyRef);

  readonly notification = signal<PANotification | null>(PANotifications.current);

  constructor() {
    PANotifications.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(notification => {
      this.notification.set(notification);
    });
  }

  runAction(action: PANotificationAction): void {
    action.handler();
    // Ohne keep_open verhält sich der Knopf wie das frühere „ok" und schließt die Meldung
    if (!action.keep_open) {
      const current = this.notification();
      if (current) PANotifications.dismiss(current.id);
    }
  }
}
